import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';
import { cautionModalContinueButton, cautionModalText, stickyContainer } from '../Helpers';

interface ShowCautionModalProps {
    setShowCaution(): void;
    autoCall: boolean;
    ticketNumber: string | undefined;
}

export const ShowCautionModal: FC<ShowCautionModalProps> = (props: ShowCautionModalProps) => {
    return (
        <fabric.Stack styles={stickyContainer}>
            <fabric.Modal
                className={'caution'}
                isOpen={true}
                isModeless={true}
                styles={{
                    main: {
                        backgroundColor: '#4d4d4d'
                    },
                    scrollableContent: {
                        minWidth: '95vw',
                        minHeight: '80vh',
                        overflow: 'hidden'
                    }
                }}
            >
                <fabric.Stack.Item
                    align="center"
                    styles={{ root: { padding: '5vw', overflow: 'hidden', backgroundColor: '#4d4d4d', color: '#e6e7e8' } }}
                >
                    {props.autoCall ? (
                        <fabric.Stack horizontalAlign="center">
                            <fabric.Text style={{ fontSize: 'calc(100px + 1vw)', textAlign: 'center' }}>KVIEČIAMA</fabric.Text>
                            <fabric.Text style={{ fontSize: 'calc(300px + 1vw)', color: '#009245', textAlign: 'center' }}>
                                {props.ticketNumber}
                            </fabric.Text>
                        </fabric.Stack>
                    ) : (
                        <fabric.Stack horizontalAlign="center">
                            <fabric.Text className="cautionModalCenterVertical" styles={cautionModalText}>
                                JŪSŲ EILĖJE YRA LAUKIANČIŲ PACIENTŲ
                            </fabric.Text>
                        </fabric.Stack>
                    )}

                    <fabric.Stack horizontalAlign="center" className={`${!props.autoCall && 'cautionButtonVerticalCenter'}`}>
                        <fabric.Stack.Item styles={{ root: { margin: '1vw' } }}>
                            <fabric.PrimaryButton
                                styles={cautionModalContinueButton}
                                onClick={() => props.setShowCaution()}
                            >
                                Tęsti
                            </fabric.PrimaryButton>
                        </fabric.Stack.Item>
                    </fabric.Stack>
                </fabric.Stack.Item>
            </fabric.Modal>
        </fabric.Stack>
    );
};
